import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "../TandemTypes";

export type LogErasedPayload = {
  num_erased: number;
};

export type LogErasedEvent = {
  numErased: number;
};

const logErasedSchema = z.object({
  num_erased: z.number(),
});

export const LID_LOG_ERASED = {
  value: 0x00,
  name: "Log Erased Event",
  format: "i............",
  fields: ["num_erased"],
  postprocess: rec => ({
    numErased: rec.num_erased,
  }),
  schema: logErasedSchema,
} as const satisfies TandemEventDefinition<LogErasedPayload, LogErasedEvent>;
